import React, { useCallback, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import { maxFlightChildAge, maxFlightInfantAge, maxFlightPassengerCount } from 'constants/flight'
import FlightSearchWidgetDispatchContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetDispatchContext'
import FlightSearchWidgetStateContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateContext'
import { FlightSearchWidgetActions } from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateReducer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import OccupancyItemVertical from 'components/Common/OccupancyPicker/OccupancyItemVertical'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import InfantSeatNoticeMessage from 'components/Flights/Common/InfantSeatNoticeMessage/InfantSeatNoticeMessage'

const TravellersContainer = styled(VerticalSpacer)`
  ${mediaQueryUp.tablet} {
    width: ${rem(416)};
  }
`

function FlightSearchTravellerSelectContent() {
  const intl = useIntl()
  const state = useContext(FlightSearchWidgetStateContext)
  const dispatch = useContext(FlightSearchWidgetDispatchContext)

  const { occupants } = state

  const onChangeOccupants = useCallback(
    (_itemId: number, nextOccupancy: App.Occupants) => {
      const infants = nextOccupancy.adults < (nextOccupancy.infants || 0) ? nextOccupancy.adults : nextOccupancy.infants
      const newOccupancies = { ...nextOccupancy, infants }

      dispatch({
        type: FlightSearchWidgetActions.SET_OCCUPANTS,
        occupants: newOccupancies,
      })
    },
    [dispatch],
  )

  const capacity = useMemo(() => {
    return [{
      adults: maxFlightPassengerCount,
      children: maxFlightPassengerCount,
      teenagers: 0,
      infants: Math.min(maxFlightPassengerCount, occupants.adults),
      total: maxFlightPassengerCount,
    }]
  }, [occupants])

  const childrenAgeLabel = intl.formatMessage({
    id: 'XxZPAoKaIAOJsGJc15lZ',
    defaultMessage: 'at time of return flight',
    description: 'Age label clarification for children in flight traveller selection',
  })

  const childrenLabel = intl.formatMessage(
    {
      id: 'u94b99AQC5n2W-p3Z32f',
      defaultMessage: 'Aged {minAge} - {maxAge}',
      description: 'Age range label for children in flight traveller selection',
    },
    { minAge: maxFlightInfantAge + 1, maxAge: maxFlightChildAge },
  )

  const infants = occupants.infants || 0
  const showInfantsWarning = infants > 0

  return (
    <TravellersContainer gap={24}>
      <OccupancyItemVertical
        itemId={0}
        occupancy={occupants}
        onChange={onChangeOccupants}
        capacities={capacity}
        childVariant="infants"
        maxChildAge={maxFlightChildAge}
        maxInfantAge={maxFlightInfantAge}
        childrenAgeLabel={childrenAgeLabel}
        childrenLabel={childrenLabel}
      />

      {showInfantsWarning && <InfantSeatNoticeMessage minified />}
    </TravellersContainer>
  )
}

export default FlightSearchTravellerSelectContent
